module.exports = __webpack_public_path__ + "img/transfer.202c2668.svg";